import { Link } from "react-router-dom";
import { appConfig } from "../lib/config";

type BrandProps = {
  inverse?: boolean;
  compact?: boolean;
  /** Destino do link. No painel autenticado use "/app"; na landing fica "/". */
  to?: string;
};

export function Brand({
  inverse = false,
  compact = false,
  to = "/",
}: BrandProps) {
  return (
    <Link
      className={`brand ${inverse ? "brand--inverse" : ""}`}
      to={to}
      aria-label={`${appConfig.name}, página inicial`}
    >
      <svg
        className="brand__mark"
        viewBox="0 0 40 40"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="apexora-brand" x1="4" y1="4" x2="36" y2="36">
            <stop stopColor="#26c6e8" />
            <stop offset=".48" stopColor="#7251f7" />
            <stop offset="1" stopColor="#4b1de1" />
          </linearGradient>
        </defs>
        <path
          d="M20 3.5 35.4 12v16L20 36.5 4.6 28V12L20 3.5Zm0 6.1-9.9 5.45v9.9L20 30.4l9.9-5.45v-9.9L20 9.6Z"
          fill="url(#apexora-brand)"
        />
        <path
          d="m10.1 15.05 9.9 5.46 9.9-5.46v5.7L20 26.2l-9.9-5.45v-5.7Z"
          fill="white"
          fillOpacity=".9"
        />
      </svg>
      {compact ? null : <span>{appConfig.name}</span>}
    </Link>
  );
}
